<template>
  <div>
     <div class="b-kyc-data">
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': get_tab_view == 'kyc' }"
      :to="{ name: 'kyc-details',  params: { status: 'Pending'  } }">
      Kyc 
    </router-link>
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': get_tab_view == 'ckyc' }"
      :to="{ name: 'ckyc-details',  params: { status: 'CKycVerificationPending'  } }">
      CKYC
    </router-link>  
    </div>
    <router-view 
      v-title="'KYC auto Verification'"
      :key="$route.fullPath">
    </router-view>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  mounted() {

    if (this.$route.name == "dashboard"){
      this.$router.push("/kyc-details/Pending");
    }
    // this.$router.push({ name: this.$route.name, params: { status: this.$route.params.status } });
    
  },

  computed: {
    get_tab_view(){
      return this.$route.name.split("-")[0]
    }
  }
  
};
</script>



<style scoped>
.row-highlight {
  background-color: #24cdc6;
}
.amc-option {
  width: 285px;
  margin: 1px;
  height:34px;
  font-size:15px;
}

.b-kyc-data{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 75px;
  justify-content: center;
}
.b-kyc-data-button {
  font-size: 2em !important;
  line-height: 2em !important;
  margin-top:10px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  border-color: #03b9f5;  
  padding: 5px;
  text-decoration: none;
}
.b-kyc-data-button-highlight {
  background-color: #03b9f5;
  color: white;
}

input {
  margin: 15px auto;
  display: block;
  width: 50%;
  padding: 8px;
  border: 1px solid black;
}

.b-container-btn {
  text-align: center;
  cursor: pointer;
}
  
.b-margin{
  margin-right: 20px;
}
</style>
